import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import FormLabel from '@material-ui/core/FormLabel';

import './styles.less';

const PhoneNumber = ({
  input,
  meta,
  country = 'us',
  label = 'Phone Number',
  ...rest
}: {
  input: any;
  meta: any;
  country: string;
  label: string;
}): React.ReactElement => {
  const [countryCode, setCountryCode] = useState(country.toLowerCase());
  const [inputValue, setInputValue] = useState(input.value);

  useEffect(() => {
    if (!inputValue) {
      setCountryCode(country.toLowerCase());
    }
  }, [country]);

  useEffect(() => {
    if (input.value !== inputValue) {
      input.onChange(inputValue);
    }
  }, [inputValue]);

  useEffect(() => {
    if (input.value !== inputValue) {
      setInputValue(input.value);
    }
  }, [input.value]);

  return (
    <>
      <PhoneInput
        {...rest}
        {...input}
        country={countryCode || 'us'}
        placeholder="Phone Number"
        error={!!meta.error}
        containerClass={`phone-input ${meta.error ? 'phone-input--error' : ''}`}
        defaultErrorMessage={meta.error}
        value={inputValue}
        onChange={(value) => setInputValue(value)}
        specialLabel={`${label}${rest.required ? ' *' : ''}`}
        // NOTE-EV: This is necessary to disable the automatic updating of values with only the country codes in the store when the user is just navigating through the form
        onBlur={() => {}}
      />
      {meta.dirty && meta.error && (
        <div>
          <FormLabel error style={{ fontSize: 12, marginTop: 10, marginLeft: 10 }}>
            {meta.error}
          </FormLabel>
        </div>
      )}
    </>
  );
};

export default PhoneNumber;
